<template>
<div class="vendorManagement">
  <el-card class="box-card" shadow="never">
    <div class="wrap-page">
      <el-button type="primary" size="small" @click="openDialog('add', {})" style="margin-bottom: 15px;">新增</el-button>
      <el-table :data="tableData" border height="660" style="width: 100%;">
        <el-table-column type="index" label="序号" width="100" align="center"></el-table-column>
        <el-table-column prop="name" label="名称" align="center"></el-table-column>
        <el-table-column prop="telephone" label="电话" align="center"></el-table-column>
        <el-table-column prop="dateTime" label="创建时间" align="center"></el-table-column>
        <el-table-column prop="address" label="地址" align="center"></el-table-column>
        <el-table-column prop="remark" label="描述" align="center"></el-table-column>
        <el-table-column fixed="right" label="操作" align="center" min-width="100">
          <template slot-scope="{ row }">
            <el-button class="btn" type="text" icon="el-icon-edit" size="small" @click="openDialog('edit', row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-card>
  <Dialog ref="vendorManageDialog" :title="dialogTitle + '配置'">
    <el-form :model="vendorManageData" label-width="80px">
      <el-form-item label="名称:">
        <el-input v-model="vendorManageData.name" placeholder="名称" style="width: 80%;"></el-input>
      </el-form-item>
      <el-form-item label="电话:">
        <el-input v-model="vendorManageData.telephone" placeholder="电话" style="width: 80%;"></el-input>
      </el-form-item>
      <el-form-item label="地址:">
        <el-input v-model="vendorManageData.address" placeholder="地址" style="width: 80%;"></el-input>
      </el-form-item>
      <el-form-item label="描述:">
        <el-input v-model="vendorManageData.remark" placeholder="描述" style="width: 80%;"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit()" style="margin-left: 36%;transform: translateX(-50%);">提交</el-button>
      </el-form-item>
    </el-form>
  </Dialog>
</div>
</template>

<script>
import Dialog from '@/components/dialog';
import VENDORAPI from '@/api/vendorManagement';
export default {
  data() {
    return {
      tableData: [],
      dialogTitle: '新增',
      vendorManageData: {
        id: "",
        name: "",
        telephone: "",
        address: "",
        remark: ""
      },
      type: 'add'
    };
  },
  components: {
    Dialog
  },
  created() {
    this.searchManufacturerList();
  },
  watch: {},
  methods: {
    searchManufacturerList() {
      VENDORAPI.searchManufacturerList().then(res => {
        if (res.data.code == 200) {
          this.tableData = res.data.data;
        }
      });
    },
    openDialog(type, row) {
      if (type == "add") {
        this.dialogTitle = '新增';
        this.vendorManageData = {};
      } else {
        this.dialogTitle = '修改';
        this.vendorManageData = row;
      }
      this.type = type;
      this.$refs.vendorManageDialog.open();
    },
    onSubmit() {
      let params = this.vendorManageData;
      if (this.type == 'add') {
        VENDORAPI.addManufacturer(params).then(res => {
          if (res.data.code == 200) {
            this.$message({
              type: "success",
              message: "添加成功！"
            })
            this.searchManufacturerList();
          }
        });
      } else {
        VENDORAPI.updateManufacturer(params).then(res => {
          if (res.data.code == 200) {
            this.$message({
              type: "success",
              message: "修改成功！"
            })
            this.searchManufacturerList();
          }
        });
      }
      this.$refs.vendorManageDialog.close();
    }
  }
};
</script>

<style lang="scss" scoped>
.box-card {
  width: 100%;
  height: 100%;
  padding-bottom: 10px;

  .leftTree {
    float: left;
    border-right: 1px solid;
    width: 300px;
    height: 71vh;
    padding-right: 20px;

    .filter-tree {
      height: 100%;
      margin-top: 20px;
      overflow: auto;
    }

    .custom-tree-node {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      overflow-x: auto;
      padding-right: 20px;

      &::-webkit-scrollbar {
        height: 3px;
      }
    }

    >>> .el-tree-node__content {
      height: 35px;
      line-height: 25px;
    }
  }

  .rightTable {
    float: left;
    width: calc(100% - 300px);
    padding: 10px 0px 10px 20px;
  }

  .btn {
    padding: 0px;
    font-size: 12px !important;

    &span {
      font-size: 12px !important;
    }
  }

  button.el-button.btn.el-button--text.el-button--mini {
    margin-left: 5px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/boss/vendorManagement/index.vue